module.exports = __webpack_public_path__ + "img/ez_yes.e5f820b9.png";